<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<b-input-group>
					<b-input-group-prepend>
						<b-button @click="home()" variant="primary"><icon name="home"/></b-button>
						<b-button @click="parent()" variant="primary" :disabled="path.length <= 1"><icon name="chevron-left"/></b-button>
					</b-input-group-prepend>
					<b-form-input id="path-id" type="text" v-model="path" autofocus required placeholder="Enter the file system path"></b-form-input>
					<b-input-group-append>
						<b-button @click="pageChange()" variant="primary"><icon name="chevron-right"/></b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col>
				<b-input-group>
					<b-form-input id="filter-id" type="text" v-model="filter" @keyup="filterData()" autofocus required placeholder="Filter the current folder"></b-form-input>
					<b-input-group-append>
						<b-button variant="primary"><icon name="filter"/></b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-table bordered striped hover responsive  :fields="fields" :items="files" :current-page="pageNo" @row-clicked="onRowClick" :per-page="rowsPerPage">
					<template #cell(size)="file">
						<span v-if="file.item.folder === false">
							{{file.item.size | size}} 
							<icon name="file" style="color: #777"/>
						</span>
						<span v-if="file.item.folder === true">
							<icon name="folder" style="color: #777"/>
						</span>
					</template>
				</b-table>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				{{totalRows | integer }} Files
			</b-col>
			<b-col class="d-flex justify-content-end">
				<span class="d-inline-flex p-2">
					<b-form-select id="per-page-select" v-model="rowsPerPage">
						<b-form-select-option :value="10">10</b-form-select-option>
						<b-form-select-option :value="20">20</b-form-select-option>
						<b-form-select-option :value="50">50</b-form-select-option>
						<b-form-select-option :value="100">100</b-form-select-option>
					</b-form-select>
				</span>
				<span class="d-inline-flex p-2">
					<b-pagination v-model="pageNo" :total-rows="totalRows" :per-page="rowsPerPage"/>
				</span>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
import {HTTP} from '../services/HttpService'

export default {
  name: 'console',
  data: () => ({
    path: '/',
    filter: '',
    allFiles: [],
    files: [],
    fields: [{
      key: 'size',
      sortable: true,
      tdClass: 'text-right'
    }, {
      key: 'name',
      sortable: true
    }, {
      key: 'permission'
    }, {
      key: 'owner',
      sortable: true
    }, {
      key: 'group',
      sortable: true
    }, {
      key: 'replication',
      sortable: true
    }, {
      key: 'accessTime',
      sortable: true
    }, {
      key: 'modificationTime',
      sortable: true
    }],
    table: [],
    pageOptions: [10, 20, 50, {
      value: 100, text: 'Show a lot'
    }],
    pageNo: 1,
    totalRows: 0,
    rowsPerPage: 10
  }),
  methods: {
    pageChange () {
      if (this.path === '') {
        this.path = '/'
      }
      HTTP.get('api/filesystem', {
        params: {
          path: this.path
        }
      })
      .then(response => {
        this.allFiles = response.data
        this.files = response.data
        this.totalRows = this.files.length
      })
    },
    filterData () {
      if (this.filter === '') {
        this.files = this.allFiles
        this.totalRows = this.files.length
        return
      }
      this.files = []
      for (var file of this.allFiles) {
        var text = file.name.toLowerCase()
        console.log(text)
        if (text.indexOf(this.filter) >= 0) {
          this.files.push(file)
        }
      }
      this.totalRows = this.files.length
      this.pageNo = 1
      return this.files
    },
    home () {
      this.path = '/'
      this.pageChange()
    },
    parent () {
      var parentPath = this.path.trim()
      if (parentPath === '/') {
        return
      }
      var index = parentPath.lastIndexOf('/')
      parentPath = parentPath.substring(0, index + 1)
      if ((parentPath.endsWith('/')) && (parentPath !== '/')) {
        parentPath = parentPath.substring(0, parentPath.length - 1)
      }
      this.path = parentPath
      this.pageChange()
    },
    openFolder (fullPath) {
      this.path = fullPath
      this.pageChange()
    },
    onRowClick (item, index, event) {
      if (item.folder === true) {
        this.openFolder(item.fullPath)
      }
    }
  },
  created () {
    console.log('here')
    this.pageChange()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FileSystemExplorer.vue?431eab64